var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:2px;}.cls-2{fill:currentColor;}")), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,8.16h0a10.5,10.5,0,0,1,10.5,10.5v1a0,0,0,0,1,0,0H1.5a0,0,0,0,1,0,0v-1A10.5,10.5,0,0,1,12,8.16Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 7.23,
    cy: 14.84,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 16.77,
    cy: 14.84,
    r: 0.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3.41,
    y1: 3.39,
    x2: 6.27,
    y2: 9.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 20.59,
    y1: 3.39,
    x2: 17.73,
    y2: 9.11
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.d4053f9a790bca0d286a4a22cef7d53d.svg";
export { ForwardRef as ReactComponent };